export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "boulparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "boulparyaj-themeWrapLive" */'./LiveThemeImporter'),
  },
};
